module.exports = __webpack_public_path__ + "static/pie_painter_11-edba996ad1db47b1fde732aafb1908a2.png";